var addcart_tooltip;
var $template;
$(function(){
  $template = $('#js_template').val();
  if ($template.includes('customers/account')) {
    initPajinateAccountPage();
  }

  if ($template == 'product.dajiahao' || $template == 'product.nihaoma') {
    initDajiahaoGallery();
  }

  redirectNonVip();

  $('.form_backendform').submit(function(){
    $(this).children('button[type=submit]').prop('disabled', true).addClass('disabled');
  });
})

submitBallotForm = () =>{
  // Fill in all iframe form
  // Get Firstname, last name, email
  //
  // var iframe = document.getElementById('frame_83lBkJ7yHwnp_GpVeuxkdg');
  // console.log(iframe);
  // var elmnt = iframe.contentWindow.document.getElementsById("form_input_0")[0];
  //
  // iframe.contentWindow.document.getElementsById("form_input_0")[0].value = $('#ballot_customer').attr('data-firstname');
  //
  // console.log(elmnt, $('#ballot_customer').attr('data-firstname'));

  $("#form_input_0").val($('#ballot_customer').attr('data-firstname'));
  $("#form_input_1").val($('#ballot_customer').attr('data-lastname'));
  $("#form_input_2").val($('#ballot_customer').attr('data-email'));

  $("#form_input_3").val($('#size_selection').val());
  $("#form_input_4").val($('#pickup_location').val());

  console.log($("#form_input_3"), $("#form_input_0"), $(".form_submit_div").find('button'));
  setTimeout(() => $(".form_submit_div").find('button').click(), 1000);
}

initDajiahaoGallery = () => {
  $('.dajiahao_gallery').flickity({
    prevNextButtons: false
  });
}

initTooltip = () => {
  const template = document.getElementById('example');
  const container = document.createElement('div.popperdiv');
}

initPajinateAccountPage = () => {
  $('#vip_page_container').pajinate({
    items_per_page : 6,
    wrap_around: true,
    show_first_last: false
  });
  $('#non_vip_page_container').pajinate({
    items_per_page : 6,
    wrap_around: true,
    show_first_last: false
  });
}

getCart = () => {
  $.getJSON("/cart.js", function(result){
    return result;
  });
}

goToCheckout = (id) => {
  event.preventDefault();
  event.stopPropagation();
  console.log(id, window.location.href);
  if (window.location.href.includes('?variant=')) {
    var _id = window.location.href.split('?variant=');
    window.location.href = "https://limited-edt.myshopify.com/cart/"+_id[1]+":1"
  }
  else {
    window.location.href = "https://limited-edt.myshopify.com/cart/"+id+":1"
  }

}

tippyJSMessage = () => {
  $('.showhere').fadeIn(500);

  setTimeout(() => $('.showhere').fadeOut(500), 4000);
}


popupForm = () => {
  event.preventDefault();
  event.stopPropagation();

  $('.js-modal').toggle();
}

redirectNonVip = () =>{
  var current_url = window.location.href;
  var customer = $('#customerInput');
  if (current_url.includes('vip-specials')) {
    if (!customer.val()) {
      window.location.href = "/account/login";
    } else if (!customer.attr('data-tags').toLowerCase().includes('vip')) {
      window.location.href = "/pages/vip-program-requirements";
    }
  }
}

hideOnClick = (evt) =>{
  $this = $(evt);
  $('<h2 style="font-weight: bold;">One purchase per customer only</h2>').insertAfter($this.parent('.popperdiv'));
  $this.parent('.popperdiv').hide();

}

refresh = (evt) =>{
  setTimeout(function(){
    location.reload();
  },900);
}
